export const P360_LOGO = process.env.PUBLIC_URL + "/P360.png";
export const PIERSOFT_LOGO = process.env.PUBLIC_URL + "/logo3-22-03-16.png";
